export function replaceAll(str, find, replace) {
  return str.replace(new RegExp(escapeRegExp(find), "g"), replace);
}

function escapeRegExp(string) {
  return string.replace(/[.*+\-?^${}()|[\]\\]/g, "\\$&");
}

export function InsertStringInToString(target, string, position) {
  return [target.slice(0, position), string, target.slice(position)].join("");
}

export function InsertZeroes(string, number) {
  while (string.length < number) {
    string = "0" + string;
  }
  return string;
}

export function InsertSpaces(string, number) {
  while (string.length < number) {
    string = " " + string;
  }
  return string;
}


export function MakeShortVersionFromLongString(longString, maxLen) {
  if (longString.length > maxLen) {
    return longString.substring(0, maxLen) + "...";
  } else {
    return longString;
  }
}

export function ArrayToStringAndAddVerticalBarBetweenIndexes(array) {
  let value = "";
  for (let index = 0; index < array.length; index++) {
    value += " | " + array[index];
    if (index == array.length - 1) {
      value += " | ";
    }
  }
  return value;
}
